<app-navbar-style-one></app-navbar-style-one>

<div id="carouselExample" class="carousel slide" data-bs-ride="carousel">
  <div class="carousel-inner">
    <div *ngFor="let offer of offers; let i = index" 
         class="carousel-item" 
         [class.active]="i === 0">
      <a class="w-100 h-100" href="/offers"><img [src]="offer.image" class="d-block w-100" [alt]="'Slide ' + (i + 1)"></a>
    </div>
  </div>
  <button class="carousel-control-prev" type="button" data-bs-target="#carouselExample" data-bs-slide="prev">
    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Previous</span>
  </button>
  <button class="carousel-control-next" type="button" data-bs-target="#carouselExample" data-bs-slide="next">
    <span class="carousel-control-next-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Next</span>
  </button>
</div>

<section class="build-your-own-section">
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-3 col-md-3 text-center make-border">
                <img class="own-section-image" src="../../../../assets/img/home2/left-side.png" alt="Build Your Own Section Image">
            </div>
            <div class="col-lg-6 col-md-6 text-center py-3 make-border">
                <div class="d-flex flex-column justify-content-center align-items-center h-100">
                    <div>
                        <p class="title">Build Your Own</p>
                        <!-- <p class="px-2">Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu.</p> -->
                        <a href="custom-food" class="btn btn-primary px-5">Start now</a>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-md-3 text-center make-border">
                <img class="own-section-image" src="../../../../assets/img/home2/right-side.png" alt="Build Your Own Section Image">
            </div>
        </div>
    </div>
</section>

<section class="order-steps-container">
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-6 col-md-5 order-md-1 order-sm-2 order-2">
                <div class="section-title">
                    <p>EASY ORDER IN 4 STEPS</p>
                    <h2>How We Work</h2>
                </div>
                <div class="row">
                    <div class="col-lg-6 col-md-12">
                        <div class="feature-box animate__animated animate__fadeInLeft">
                            <div class="feature-icon">
                                <img src="assets/img/home2/first.png" alt="Explore Menu">
                            </div>
                            <h4>Explore Menu</h4>
                            <p>Browse through our mouth-watering selection of authentic pizzas, fresh pastas, and delicious sides.</p>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-12">
                        <div class="feature-box animate__animated animate__fadeInLeft">
                            <div class="feature-icon">
                                <img src="assets/img/home2/second.png" alt="Choose a Dish">
                            </div>
                            <h4>Choose a Dish</h4>
                            <p>Pick your favorite Roma Pizza flavor, customize your toppings, and get ready for a treat.</p>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-12">
                        <div class="feature-box animate__animated animate__fadeInLeft">
                            <div class="feature-icon">
                                <img src="assets/img/home2/third.png" alt=" Fast Delivery">
                            </div>
                            <h4>Place Order</h4>
                            <p>Add your delicious choices to the cart and get ready for a fast, fresh delivery straight to your doorstep.</p>
                        </div>
                    </div>
                        <div class="col-lg-6 col-md-12">
                        <div class="feature-box animate__animated animate__fadeInLeft">
                            <div class="feature-icon">
                                <img src="assets/img/home2/forth.png" alt="Top Chefs">
                            </div>
                            <h4>Checkout</h4>
                            <p>Complete your payment securely and easily. We will start baking your Roma Pizza right away!</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-7 order-md-2 order-sm-1 order-1 d-flex justify-content-center align-items-center mb-4 mb-md-0 pe-0">
                <div class="text-center">
                    <img src="assets/img/home2/cooker.png" class="cooker-image animate__animated animate__fadeInRight" alt="Cooker Image">
                </div>
            </div>
        </div>
    </div>
</section>

<!-- <section class="featured-products-section">
  <div class="carousel-container">
    <div class="carousel-wrapper">
      <div class="carousel-arrows">
        <h1 class="carousel-title">Explore product</h1>
        <div class="d-flex" style="justify-content: space-around;">
            <div class="carousel-arrow prev-arrow" (click)="prevSlide()">
                <i class="bx bx-chevron-left"></i>
            </div>
            <div class="carousel-arrow next-arrow" (click)="nextSlide()">
                <i class="bx bx-chevron-right"></i>
            </div>
        </div>
      </div>
      
      <div class="carousel-slide" *ngFor="let slide of slides; let i = index" 
           [class.active]="i === currentSlide">
        <div class="product-card" *ngFor="let product of slide">
          <div class="product-image">
            <img [src]="product.image" [alt]="product.name">
          </div>
          <div class="product-info text-center">
            <h3 class="product-title">{{ product.name }}</h3>
            <p class="product-description">{{ product.description }}</p>
            <div class="d-flex justify-content-between">
                <span class="product-price">{{ product.price }}</span>
                <button class="add-to-cart" (click)="addToCart(product)"><i class="bx bx-cart"></i></button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section> -->

<section class="lunch-menu mt-5 px-2 py-2">
    <div class="row">
        <div class="col-md-4" style="display: flex;align-content: center;align-items: center;">
            <div class="menuLunchCatering">
                <h3 class="title">Main Menu</h3>
                <p class="paragraph mt-3">Enjoy our complete main menu for <strong style="color: #C71D1D;font-size: 16px;font-weight: 800;">lunch</strong> — all your favorite Roma pizzas and sides, available all day!</p>
                <div class="mt-5">
                    <a href="/mainMenu" class="btn btn-primary px-5">Show more</a>
                </div>
            </div>
        </div>
        <div class="col-md-4 d-flex justify-content-center align-items-center text-center">
            <a href="/mainMenu">
                <img src="{{lunchImage}}" class="img-fluid text-center animate__animated animate__backInLeft" width="250" alt="lunch">
            </a>
        </div>
        <div class="col-md-4 d-flex align-items-center">
            <ul class="list-unstyled">
                <li><i class="bx bx-check"></i>Premium Hand-Tossed Dough</li>
                <li><i class="bx bx-check"></i>Award-Winning Roma Taste</li>
                <li><i class="bx bx-check"></i>Freshly Baked Every Day</li>
                <li><i class="bx bx-check"></i>Cozy Family-Friendly Atmosphere</li>
            </ul>
        </div>
    </div>
</section>

<section class="catering-menu mt-5 px-2 py-2">
    <div class="row">
        <div class="col-md-4" style="display: flex;align-content: center;align-items: center;">
            <div class="menuLunchCatering">
                <h3 class="title">Catering</h3>
                <p class="paragraph mt-3">Hosting a party? Let us handle the food so you can actually enjoy the night with your guests!</p>
                <div class="mt-5">
                    <a href="/menu/maincategory/{{cateringCategoryId[0]}}/catering" class="btn btn-primary px-5">Show more</a>
                </div>
            </div>
        </div>
        <div class="col-md-4 d-flex justify-content-center align-items-center text-center">
            <a href="/menu/maincategory/{{cateringCategoryId[0]}}/catering">
                <img src="{{cateringImage}}" class="img-fluid text-center animate__animated animate__backInLeft" width="250" alt="lunch">
            </a>
        </div>
        <div class="col-md-4 d-flex align-items-center">
            <ul class="list-unstyled">
                <li><i class="bx bx-check"></i>Premium Hand-Tossed Dough</li>
                <li><i class="bx bx-check"></i>Award-Winning Roma Taste</li>
                <li><i class="bx bx-check"></i>Freshly Baked Every Day</li>
                <li><i class="bx bx-check"></i>Cozy Family-Friendly Atmosphere</li>
            </ul>
        </div>
    </div>
</section>

<section class="mt-5 menuMenu">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-12 text-center">
                <h3>What’s Being Served?</h3>
                <p class="mt-2 mb-4 tableServe" style="padding: 0 20%;">Discover today’s fresh flavors crafted just for you</p>
            </div>
        </div>
    </div>
   
    <div class="container-fluid px-0 mb-5">
        <div class="menu-table">
            <div class="menu-table-row">
                <div *ngFor="let item of menuItems" class="menu-table-cell">
                    <div class="menu-item">
                        <div class="menu-icon">
                            <a class="menuImage" routerLink="menu/subcategory/{{item.id}}/{{item.name}}">
                                <img [src]="item.avatar" [alt]="item.name" width="150" class="img-fluid">
                            </a>
                        </div>
                        <h5>
                            <a routerLink="menu/subcategory/{{item.id}}/{{item.name}}">{{item.name}}</a>
                        </h5>
                    </div>
                </div>
            </div>
        </div>
    </div>

</section>

<section class="why-choose-section">
    <div class="container-fluid px-0">
            <!-- Section Title -->
            <div class="text-center">
                <div class="section-title">
                    <h2>WHY CHOOSE US</h2>
                </div>
            </div>

            <!-- Features Container with Background -->
            <div class="features-container">
                <div class="container">
                    <div class="row features-row g-4">
                        <!-- Feature 1 -->
                        <div class="col-lg-3 col-md-6">
                            <div class="feature-card">
                                <div class="feature-icon">
                                    <img src="../../../../assets/img/home2/chef.png">
                                    <!-- <span class="icon-chef"></span> -->
                                </div>
                                <h4>Professional Chefs</h4>
                                <p>Expert hands crafting the perfect Roma Pizza, bringing authentic Italian excellence right to your table.</p>
                            </div>
                        </div>
                        
                        <!-- Feature 2 -->
                        <div class="col-lg-3 col-md-6">
                            <div class="feature-card">
                                <div class="feature-icon">
                                    <img src="../../../../assets/img/home2/burger2.png">
                                    <!-- <span class="icon-burger"></span> -->
                                </div>
                                <h4>Items Of Food</h4>
                                <p>A delicious variety of freshly baked pizzas and mouth-watering sides made with premium ingredients.</p>
                            </div>
                        </div>
                        
                        <!-- Feature 3 -->
                        <div class="col-lg-3 col-md-6">
                            <div class="feature-card">
                                <div class="feature-icon">
                                    <img src="../../../../assets/img/home2/utensils.png">
                                    <!-- <span class="icon-utensils"></span> -->
                                </div>
                                <h4>Years Of Experienced</h4>
                                <p>Long-standing expertise in perfecting our secret dough and signature recipes for the ultimate slice.</p>
                            </div>
                        </div>
                        
                        <!-- Feature 4 -->
                        <div class="col-lg-3 col-md-6">
                            <div class="feature-card">
                                <div class="feature-icon">
                                    <img src="../../../../assets/img/home2/pizza2.png">
                                    <!-- <span class="icon-pizza"></span> -->
                                </div>
                                <h4>Happy Customers</h4>
                                <p>Thousands of satisfied pizza lovers who always choose Roma Pizza for an unforgettable meal.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
</section>


<app-footer-style-two></app-footer-style-two>